import { render, staticRenderFns } from "./digitCockpitCopy.vue?vue&type=template&id=9356485c&scoped=true"
import script from "./digitCockpitCopy.vue?vue&type=script&lang=js"
export * from "./digitCockpitCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9356485c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9356485c')) {
      api.createRecord('9356485c', component.options)
    } else {
      api.reload('9356485c', component.options)
    }
    module.hot.accept("./digitCockpitCopy.vue?vue&type=template&id=9356485c&scoped=true", function () {
      api.rerender('9356485c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/digitCockpit/digitCockpitCopy.vue"
export default component.exports